export default __webpack_public_path__ + "static/media/pic3.37e1bd2f.jpg";